import { styled } from "@mui/material";

export const Styled = {
    Panel: styled("div")`
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 16px;
        max-width: 640px;
    `,
};
